import ability from '@/libs/acl/ability'
import { initialAbility } from '@/libs/acl/config'

export function clearAuthStorage() {
  window.localStorage.clear()
  window.sessionStorage.clear()
  ability.update(initialAbility)
}
